import { IonIcon } from '@ionic/react';
import { create, trash } from 'ionicons/icons';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { db } from '../../../db';
import Swal from 'sweetalert2';

export default function TdTeacher(props) {
  const { i18n, t } = useTranslation();
  const [subject, setSubject] = useState([]);
  useEffect(() => {
    if (props.item.subject_id) {
      db.subjects.get(Number.parseInt(props.item.subject_id)).then((res) => {
        if (res) {
          setSubject(res);
        }
      });
    }
  }, [props.item.subject_id]);

  const [classe, setClasse] = useState([]);
  useEffect(() => {
    if (props.item.class_id) {
      db.classes.get(Number.parseInt(props.item.class_id)).then((res) => {
        if (res) {
          setClasse(res);
        }
      });
    }
  }, [props.item.class_id]);

  const [classroom, setClassroom] = useState([]);
  useEffect(() => {
    if (props.item.classroom_id) {
      db.classrooms
        .get(Number.parseInt(props.item.classroom_id))
        .then((res) => {
          if (res) {
            setClassroom(res);
          }
        });
    }
  }, [props.item.classroom_id]);

  const deleteItem = (e, item) => {
    e.preventDefault();

    Swal.fire({
      title: t("delete session"),
      html: `
      <div>
        ${i18n.language == "ar" ? `هل أنت متأكد من حذف حصة ${subject.name} من الساعة ${item.start_time} إلى ${item.end_time} ؟` : `${t("delete verification")} the ${subject.name} session from ${item.start_time} to ${item.end_time} ?`}
      </div>
    `,
      showDenyButton: true,
      confirmButtonText: t("delete"),
      denyButtonText: t("cancel"),
      confirmButtonColor: '#df4759',
      denyButtonColor: '#d9e2ef',
    }).then((result) => {
      if (result.isConfirmed) {
        db.sessions.delete(item.id).then(() => {
          Swal.fire(t("success"), t("session deleted successfully"), 'success');
        });
      } else if (result.isDenied) {
      }
    });
  };
  return (
    <>
      {props.item.teacher_id ? (
        <td className="border px-3 py-2 min-w-[80px]">
          <div className="grid grid-cols-12">
            <div className="col-span-4">
              <button
                type="button"
                className=""
                onClick={() => {
                  props.settoedit(props.item);
                  props.settoeditmodal(true);
                }}
              >
                <IonIcon
                  className="text-xl text-blue-500 justify-start"
                  icon={create}
                />
              </button>
            </div>
            <div className="col-span-4" />{' '}
            <div className="col-span-4">
              {' '}
              <button
                type="button"
                className=""
                onClick={(e) => deleteItem(e, props.item)}
              >
                <IonIcon
                  className="text-xl text-red-500 justify-start"
                  icon={trash}
                />
              </button>{' '}
            </div>{' '}
          </div>
          <div className="">{classe.name ? classe.name : ''}</div>
          <div className="">{subject.name ? subject.name : ''}</div>
          <div className="">{classroom.name ? classroom.name : ''}</div>
        </td>
      ) : (
        <td className="border px-3 py-2 min-w-[80px]">
          <button
            type="button"
            className="bg-blue-500 text-white font-bold rounded px-3 py-1"
            onClick={() => {
              props.settoadd(props.data);
              props.settoaddmodal(true);
            }}
          >
            +
          </button>
        </td>
      )}
    </>
  );
}
